import { BrowserRouter, Route, Routes } from 'react-router-dom'
import i18next from 'i18next'

import './App.scss'

import Feed from './pages/Feed'
import Login from './pages/Login'
import ResetPassword from './pages/Login/ResetPassword'
import SetNewPassword from './pages/Login/SetNewPassword'
import Priorities from './pages/Priorities'
import Question from './pages/Question'
import SignUp from './pages/SignUp'
import Activation from './pages/SignUp/Activation'
import Confirmation from './pages/SignUp/Confirmation/Confirmation'
import Success from './pages/Login/ResetPassword/Success'
import ProtectedRoute from './common/routes/ProtectedRoute'
import GuestRoute from './common/routes/GuestRoute'
import Profile from './pages/Profile'
import ChangePassword from './pages/Profile/ChangePassword'
import ChangePriorities from './pages/Profile/ChangePriorities'
import ChangeLanguage from './pages/Profile/ChangeLanguage'
import Warning from './pages/Warning'
import { useEffect } from 'react'
import { useUserStore } from './store/user-store'
import { getCurrentUsername, isUserLoggedIn } from './common/utils/cognito'
import { useYbugApi } from 'ybug-react'

function App() {
  const { currentUser, fetchUser } = useUserStore()
  const YbugContext = useYbugApi()

  useEffect(() => {
    const init = async () => {
      if (await isUserLoggedIn()) {
        await fetchUser()
        const userEmail = getCurrentUsername()

        YbugContext?.init({
          feedback: {
            email: userEmail,
          },
          language_override: currentUser?.language,
        })
      }
    }

    if (currentUser?.language) {
      i18next.changeLanguage(currentUser.language)

      document.documentElement.lang = currentUser.language
    }

    init()
  }, [currentUser?.language, fetchUser, YbugContext])

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<GuestRoute />}>
          <Route index element={<Login />} />
          <Route index path="login" element={<Login />} />
          <Route path="signup" element={<SignUp />} />
          <Route path="activation" element={<Activation />} />
          <Route path="confirmation" element={<Confirmation />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="set-new-password" element={<SetNewPassword />} />
          <Route path="set-new-password-success" element={<Success />} />
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route path="feed" element={<Feed />} />
          <Route path="question/:id" element={<Question />} />
          <Route path="priorities" element={<Priorities />} />
          <Route path="profile" element={<Profile />} />
          <Route path="profile/change-password" element={<ChangePassword />} />
          <Route
            path="profile/change-priorities"
            element={<ChangePriorities />}
          />
          <Route path="profile/change-language" element={<ChangeLanguage />} />
          <Route path="warning" element={<Warning />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
